import { Button, Result } from "antd";
import { useNavigate } from "react-router";
import { useI18n } from "@/i18n";

export function Forbidden() {
  const { t } = useI18n();
  const navigate = useNavigate();
  return (
    <Result
      status="403"
      title={t("page.forbidden.title")}
      subTitle={t("page.forbidden.body")}
      extra={<Button type="primary" onClick={() => navigate("/app")}>{t("page.toHome")}</Button>}
    />
  );
}

export function NotFound() {
  const { t } = useI18n();
  const navigate = useNavigate();
  return (
    <Result
      status="404"
      title={t("page.notFound.title")}
      subTitle={t("page.notFound.body")}
      extra={<Button type="primary" onClick={() => navigate("/app")}>{t("page.toHome")}</Button>}
    />
  );
}
